import CDResult from "./Result"
import CDSearchForm from './Form'
import { observer } from 'mobx-react-lite'
import state from "./State"

const CDVerify = () => {
  if (state.cd)
    return <CDResult />

  return <CDSearchForm />
}

export default observer(CDVerify)
